import React, { useState } from "react";
import { useAuth } from "@/lib/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
    const { login } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const nav = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await login(email, password);
            toast.success("Welcome back");
            nav("/admin");
        } catch {
            toast.error("Invalid email or password");
        } finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-brand-stone p-6" data-testid="admin-login-page">
            <div className="w-full max-w-md bg-white border border-black/5 rounded-2xl p-8 shadow-sm">
                <div className="flex flex-col items-center text-center gap-3 mb-6">
                    <img
                        src="https://customer-assets-39nsmqrw.emergentagent.net/job_kabir-ngo-platform/artifacts/kzxgbp73_kabir%20logo%202.png"
                        alt="Kabir Foundation"
                        className="h-28 w-auto object-contain"
                    />
                    <div className="text-xs uppercase tracking-[0.15em] text-slate-500 font-semibold">Content Management</div>
                </div>
                <form onSubmit={submit} className="space-y-4">
                    <input required type="email" placeholder="Admin email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" className="w-full px-4 py-3 rounded-lg border border-black/10 text-sm" />
                    <input required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" className="w-full px-4 py-3 rounded-lg border border-black/10 text-sm" />
                    <button type="submit" disabled={busy} data-testid="admin-login-submit" className="w-full px-6 py-3 rounded-lg bg-brand-forest text-white font-semibold hover:bg-brand-forestHover disabled:opacity-50 transition-colors duration-200 flex items-center justify-center gap-2">
                        <Lock size={16} /> {busy ? "Signing in…" : "Sign in"}
                    </button>
                </form>
            </div>
        </div>
    );
}
